// extracted by mini-css-extract-plugin
export default {"card":"C5-z"};